import { useEffect, useState } from "react";
import FullModal from "../components/FullModal"
import Loader from "../components/Loader";
import { useDebugLog } from "../hooks/useDebugLog";
import { useNavigate } from "react-router-dom";

const SetNewPassword = () => {
    const [token, setToken] = useState(null);
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        setToken(searchParams.get('token'))
    }, [])

    const [inputData, setInputData] = useState('');
    const handleInputData = (event) => {
        const { value } = event.target;
        setInputData(value);
    }
    const [fetchStatus, setFetchStatus] = useState('idle');
    const [error, setError] = useState(null);
    useDebugLog(error, 'error: ', error)

    const navigate = useNavigate();
    const sendNewPassword = async () => {
        try {
            setFetchStatus('loading');
            const url = `${process.env.REACT_APP_SERVER_BASE_URL}/users/set-new-password`;
            const headers = { 'Content-Type': 'application/json' };
            const options = { method: 'POST', headers, body: JSON.stringify({ token, newPassword: inputData }) }
            const response = await fetch(url, options);
            if(response.ok) {
                setFetchStatus('succeeded');
                setTimeout(() => {
                    navigate("/register-login?section=Login");
                }, 3000)
            } else {
                const error = await response.json();
                setError(error.message);
                setFetchStatus('failed');
            }
        } catch (error) {
            setError(error.message);
            console.log('Catch error: ', error)
                setFetchStatus('failed');
        }
    }
    return (
        <FullModal px="4" items="center">

            {
                fetchStatus === 'idle' &&
                <div className="flex flex-col items-center gap-2 w-full">
                    <label htmlFor="password">Imposta nuova:</label>
                    <input type="password" className="w-full md:w-96" onChange={handleInputData} value={inputData} />
                </div>
            }

            <div className="my-8">
                {
                    fetchStatus === 'idle' &&
                    <button className='bg-[#225424] py-2 px-3 rounded-xl text-white w-full lg:w-fit' onClick={sendNewPassword}>Imposta nuova password</button>
                }
                {
                    fetchStatus === 'loading' &&
                    <Loader />
                }
                {
                    fetchStatus === 'failed' && error &&
                    <div className="flex flex-col items-center">
                        <h3>Qualcosa è andato storto. Ricarica la pagina e riprova</h3>
                        {<h5>{error}</h5>}
                    </div>
                }
                {
                    fetchStatus === 'succeeded' &&
                    <h3 className="text-center">Nuova password memorizzata con successo, attendi il refresh della pagina.</h3>
                }

            </div>

        </FullModal>
    )
}

export default SetNewPassword;